import { ActiveLocationsMap } from './ActiveLocationsMap';

export default ActiveLocationsMap;
